import React, { Component } from 'react';
import Drawer from 'material-ui/Drawer';
import Menu, { MenuItem } from 'material-ui/Menu';
import AppBar from 'material-ui/AppBar';
import { connect } from 'react-redux';
import ScrollableAnchor from 'react-scrollable-anchor';
import { configureAnchors } from 'react-scrollable-anchor';
import { goToAnchor } from 'react-scrollable-anchor';
import ReactDOM from 'react-dom';
import IconButton from 'material-ui/IconButton';
import MenuIcon from 'material-ui-icons/Menu';
import { Grid, Row, Col } from 'react-flexbox-grid';

import { setDrawerState } from './actions';
import Profile from './Profile';
import Experience from './Experience';
import Projects from './Projects';
import Technology from './Technology';
import Education from './Education';

class Navbar extends Component {

    constructor(props) {
        super(props);

        this.state = { selectedItem: '1' };
        this.appBarColors = ['#00b7d3', '#009faf', '#00b686', '#7ecb20', '#c8a600'];
        this.drawerBgColors = ['#d7ccc8', '#d7ccc8', '#d7ccc8', '#d7ccc8', '#d7ccc8'];
        this.fontColors = ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000'];
        this.appbarHeaders = ["Profile", "Experience", "Academic & Individual Projects", "Technology", "Education" ];
        this.menuselected = "false";
    }

    componentDidMount() {
        MenuItem.defaultProps.disableTouchRipple = true;
        window.addEventListener('scroll', this.handleScroll.bind(this));
        this.setDivPosition();
        configureAnchors({ offset: 50, scrollDuration: 0 })
    }

    setDivPosition() {
        this.profileDivPosition = ReactDOM.findDOMNode(this.refs.section1).offsetTop;
        this.experienceDivPosition = ReactDOM.findDOMNode(this.refs.section2).offsetTop;
        this.projectDivPosition = ReactDOM.findDOMNode(this.refs.section3).offsetTop;
        this.technologyDivPosition = ReactDOM.findDOMNode(this.refs.section4).offsetTop;
        this.educationDivPosition = ReactDOM.findDOMNode(this.refs.section5).offsetTop;
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll.bind(this));
    }

    componentDidUpdate() {
        this.setDivPosition();
    }

    handleScroll(event) {
        let scrollTop = window.scrollY;
        if(this.menuselected) {
            this.menuselected = false;
            return;
        }
        if (scrollTop >= Math.abs(this.educationDivPosition - 60)) {
            this.setState({ selectedItem: '5' });
        } else if (scrollTop >= Math.abs(this.technologyDivPosition - 60)) {
            this.setState({ selectedItem: '4' });
        } else if (scrollTop >= Math.abs(this.projectDivPosition - 60)) {
            this.setState({ selectedItem: '3' });
        } else if (scrollTop >= Math.abs(this.experienceDivPosition - 60)) {
            this.setState({ selectedItem: '2' });
        } else if (scrollTop >= Math.abs(this.profileDivPosition)) {
            this.setState({ selectedItem: '1' });
        }
        // console.log(this.state.selectedItem);
    }

    onDrawerRequestChange(open, reason) {
        this.props.setDrawerState(false);
    }

    toggleDrawerOpen() {
        this.props.setDrawerState(true);
    }

    selectItem(e, value) {
        switch(value) {
            case '1': window.scrollTo(0, 0);
                break;
            case '2': window.scrollTo(0, this.experienceDivPosition - 55);
                break;
            case '3': window.scrollTo(0, this.projectDivPosition - 55);
                break;
            case '4': window.scrollTo(0, this.technologyDivPosition - 55);
                break;
            case '5': window.scrollTo(0, this.educationDivPosition - 55);
                break;
        }
        // window.scrollTo(0, this.educationDivPosition - 50);
        // goToAnchor('section' + value, true);
        this.setState({ selectedItem: value });
        // this.menuselected = true;
    }

    render() {
        let selectedMenuItemIndex = parseInt(this.state.selectedItem);

        const appBarProps = {
            style: {
                backgroundColor: this.appBarColors[selectedMenuItemIndex - 1],
                position: 'fixed',
                width: '100%',
                height: 60
            },
            className: 'Appbar',
            onLeftIconButtonTouchTap: this.toggleDrawerOpen.bind(this),
            iconClassNameRight: "muidocs-icon-navigation-expand-more",
            showMenuIconButton: !this.props.browser.greaterThan.medium && !this.props.responsiveDrawer.open,
            title: this.appbarHeaders[parseInt(this.state.selectedItem) - 1],
            titleStyle: { color: this.fontColors[selectedMenuItemIndex - 1],
                marginLeft: this.props.browser.greaterThan.medium || this.props.responsiveDrawer.open ? '200px' : '0px',
                textAlign: 'center',
                fontFamily: 'Bree Serif, serif',
                fontSize: '35px',
                fontWeight: 900,
                lineHeight: '72px',
                textTransform: 'uppercase',
                marginTop: -5
            }
        };

        const drawerProps = {
            docked: this.props.browser.greaterThan.medium,
            width: 200,
            open: this.props.browser.greaterThan.medium || this.props.responsiveDrawer.open,
            onRequestChange: this.onDrawerRequestChange.bind(this),
            containerStyle: { backgroundColor: this.drawerBgColors[selectedMenuItemIndex - 1] }
        };

        const selectedMenuItemStyle = {
            selectedMenuItemStyle: { 
                color: this.appBarColors[selectedMenuItemIndex - 1],
                fontFamily: 'Bree Serif, serif',
                fontSize: 20
            },
            menuItemStyle: { 
                color: 'black',
                fontFamily: 'Bree Serif, serif',
                fontSize: 17
            },
            value: this.state.selectedItem,
            onChange: this.selectItem.bind(this)
        };

        return (
            <div style={{width: '100%', height: 100}}>
                <Grid style={{ margin: 0, width: '100%', padding: 0 }}>
                    <AppBar {...appBarProps} />
                    <Drawer
                        {...drawerProps}
                        >
                        <AppBar
                            title="Portfolio"
                            showMenuIconButton={false}
                            style={{ backgroundColor: 'rgba(0,0,0,0)', boxShadow: 'none' }}
                            titleStyle={{ color: "black", fontFamily: 'Bree Serif, serif', fontSize: 30}}
                        />
                        <Menu {...selectedMenuItemStyle}>
                            <MenuItem value='1' animation="none"><i className="material-icons" style={{ verticalAlign: "middle", margin: "12px" }}>face</i>Profile</MenuItem>
                            <MenuItem value='2'><i className="material-icons" style={{ verticalAlign: "middle", margin: "12px" }}>verified_user</i>Experience</MenuItem>
                            <MenuItem value='3'><i className="material-icons" style={{ verticalAlign: "middle", margin: "12px" }}>games</i>Projects</MenuItem>
                            <MenuItem value='4'><i className="material-icons" style={{ verticalAlign: "middle", margin: "12px" }}>layers</i>Technology</MenuItem>
                            <MenuItem value='5'><i className="material-icons" style={{ verticalAlign: "middle", margin: "12px"  }}>school</i>Education</MenuItem>
                        </Menu>
                    </Drawer>
                    <ScrollableAnchor ref='section1' id={'profile'}>
                        <Profile />
                    </ScrollableAnchor>
                    <ScrollableAnchor ref='section2' id={'experience'}>
                        <Experience />
                    </ScrollableAnchor>
                    <ScrollableAnchor ref='section3' id={"projects"}>
                        <Projects />
                    </ScrollableAnchor>
                    <ScrollableAnchor ref='section4' id={"technology"}>
                        <Technology />
                    </ScrollableAnchor>
                    <ScrollableAnchor ref='section5' id={"education"}>
                        <Education />
                    </ScrollableAnchor>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { browser, responsiveDrawer } = state;
    return {
        browser,
        responsiveDrawer
    };
};

export default connect(mapStateToProps, { setDrawerState })(Navbar);


// WEBPACK FOOTER //
// ./src/Navbar.js